import React from 'react'
import { QuestionInSection } from '../EditSurvey/editSurvey.types'
import { QuestionTitle } from '../FillQuestion/QuestionTitle'
import { QuestionResultByType } from './QuestionResultByType'
import { QuestionResults } from '../../types/surveyStore.types'

interface Props {
  question: QuestionInSection
  questionOrder: number
  questionResult: QuestionResults
}

export const QuestionResult: React.FC<React.PropsWithChildren<Props>> = ({
  question,
  questionOrder,
  questionResult,
}) => {
  return (
    <>
      <QuestionTitle question={question} questionOrder={questionOrder} />
      <QuestionResultByType questionResult={questionResult} />
    </>
  )
}
